(function () {
    'use strict';

    angular
        .module('services.permission', ['services.authenticatedUser'])
        .factory('permissionService', service);

    service.$inject = ['$rootScope'];

    function service($rootScope) {
        return {
            /**
             * Checks if the current user has one of the requested permissions.
             * The permissions is checked based on: Feature (e.g. GRCControlManagement), a key (e.g. Control)
             * and a permission (e.g. Edit). The sources are: authenticated user's feature-role permissions as well
             * as (optionally) the provided object's attribute or its _GOV attribute which contains contextual
             * permissions that override the feature-role permissions.
             *
             * @param permissions (Object|Object[]) -- Contains object or array of feature role, key, permission
             */
            hasPermissions: function (permissions) {
                var srv = this;

                return (angular.isArray(permissions) ? permissions : [permissions]).some(function(permission){
                    if (permission.featureRole && permission.key && permission.permission) {
                        return srv.hasPermission(permission.featureRole, permission.key, permission.permission);
                    }
                    return !!permission;
                });
            },

            /**
             * Checks if the current user has the requested permission.
             * The permissions is checked based on: Feature (e.g. GRCControlManagement), a key (e.g. Control)
             * and a permission (e.g. Edit). The sources are: authenticated user's feature-role permissions as well
             * as (optionally) the provided object's attribute or its _GOV attribute which contains contextual
             * permissions that override the feature-role permissions.
             *
             * @param feature (string|string[]) -- Feature Role, if array, check for multiple features
             * @param key (string) -- Permission key
             * @param permission (string) -- Permission type (view, edit, etc.)
             * @param [object] (Object) -- Checks the object's attribute for contextual permissions (_GOV or direct)
             */
            hasPermission: function (feature, key, permission, object) {
                // First check the contextual permission if any as this overrides everything else
                // The _GOV contains directly Can<permission> (e.g. 'CanEdit') no need for feature or key
                if (object) {
                    if (object.hasOwnProperty('Can' + permission)) {
                        return !!object['Can' + permission];
                    } else if (object._GOV && object._GOV.hasOwnProperty('Can' + permission)) {
                        return !!object._GOV['Can' + permission];
                    } else if (object.hasOwnProperty('Has' + key + '_' + permission)) {
                        return !!object['Has' + key + '_' + permission];
                    }
                }

                var user = $rootScope.authenticatedUser;

                // Else, look into the authenticated user's permission based on feature/key/permission
                var featureList = _.isArray(feature) ? feature : [feature];
                var keyPermission = key + '_' + permission;

                return _.some(featureList, function (feat) {
                    return _.includes(user.User.UserFeatureRoles[feat], keyPermission);
                });
            },

            /**
             * Gets the permissions for the current user.
             * The permissions are based on: Feature (e.g. GRCControlManagement), a key (e.g. Control)
             * The sources are: authenticated user's feature-role permissions as well
             * as (optionally) the provided object's attribute or its _GOV attribute which contains contextual
             * permissions that override the feature-role permissions.
             *
             * @param feature (string|string[]) -- Feature Role, if array, check for multiple features
             * @param key (string) -- Permission key
             * @param [object] (Object) -- Checks the object's attribute for contextual permissions (_GOV or direct)
             */
            getPermissions: function (feature, key, object) {
                var permissions = {};

                // First check the contextual permission if any as this overrides everything else
                // The _GOV contains directly Can<permission> (e.g. 'CanEdit') no need for feature or key
                if (object) {
                    var obj = object._GOV ? object._GOV : object;

                    _.keys(obj).forEach(function(k) {
                        if (_.startsWith(k, 'Has' + key + '_')) {
                            permissions[k.replace('Has' + key + '_', '')] = obj[k];
                        } else if (_.startsWith(k, 'Can')) {
                            permissions[k.replace('Can', '')] = obj[k];
                        }
                    });
                }

                // look into the authenticated user's permission for feature keys
                var user = $rootScope.authenticatedUser;
                var featureList = _.isArray(feature) ? feature : [feature];

                var userPermissions = _.reduce(featureList, function (o, feat) {
                    var keyPermissions = user.User.UserFeatureRoles[feat];

                    if (keyPermissions) {
                        keyPermissions.forEach(function(keyPermission) {
                            if (_.startsWith(keyPermission, key + '_')) {
                                o[keyPermission.replace(key + '_', '')] = true;
                            }
                        });
                    }

                    return o
                }, {});

                return _.merge(userPermissions, permissions);
            }
        };
    }
})();